import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/article-page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // Existing articles
  { path: "/czym-jest-kakobuy-spreadsheet", element: <ArticlePage /> },
  { path: "/jak-dziala-kakobuy", element: <ArticlePage /> },
  { path: "/kakobuy-vs-pandabuy", element: <ArticlePage /> },
  { path: "/czy-kakobuy-jest-bezpieczny", element: <ArticlePage /> },
  { path: "/najlepsi-sprzedawcy-kakobuy", element: <ArticlePage /> },
  { path: "/kakobuy-links-2026", element: <ArticlePage /> },
  { path: "/najlepsze-nike-linki-kakobuy", element: <ArticlePage /> },
  { path: "/jak-kupowac-przez-agenta", element: <ArticlePage /> },
  // New SEO articles
  { path: "/kakobuy-polska", element: <ArticlePage /> },
  { path: "/kakobuy-opinie-polska", element: <ArticlePage /> },
  { path: "/kakobuy-vs-cnfans", element: <ArticlePage /> },
  { path: "/kakobuy-vs-sugargoo", element: <ArticlePage /> },
  { path: "/kakobuy-spreadsheet-2026", element: <ArticlePage /> },
  { path: "/poradnik-zakupowy-kakobuy", element: <ArticlePage /> },
  { path: "/przewodnik-poczatkujacego-kakobuy", element: <ArticlePage /> },
  { path: "/tanie-produkty-kakobuy", element: <ArticlePage /> },
  { path: "/faq-kakobuy", element: <ArticlePage /> },
  // Safety & Guides
  { path: "/jak-sprawdzic-qc", element: <ArticlePage /> },
  { path: "/jak-zamowic-do-polski", element: <ArticlePage /> },
  { path: "/jak-uniknac-oszustw", element: <ArticlePage /> },
  { path: "/bezpieczne-platnosci-kakobuy", element: <ArticlePage /> },
  // Catch-all
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;